import {
    getUniqueSlotSizeFromStandardSlot,
    SingleAdSlotSize,
    SizeMapping,
    SlotSize,
    UniqueAdSlotSize,
} from '../advertising/size-mapping'

export function getAdSize(
    sizemapping: SizeMapping[] | undefined,
    windowWidth = window.innerWidth,
): SizeMapping | null {
    if (sizemapping) {
        const sortedByViewport = sizemapping.sort((a, b) =>
            a.viewport[0] < b.viewport[0] ? 1 : -1,
        )

        for (const s of sortedByViewport) {
            if (s.viewport[0] <= windowWidth) {
                if (s.slot.length > 0) {
                    return s
                }

                return null
            }
        }
    }
    return null
}

export type FirstSlotSize = {
    gptSlot: UniqueAdSlotSize
    slot: SingleAdSlotSize
}

export function pickFirstSizeMapping(
    size: SizeMapping | null,
): FirstSlotSize | null {
    if (!size) {
        return null
    }

    return pickFirstSize(size.slot)
}

export function pickFirstSize(slot: SlotSize | null): FirstSlotSize | null {
    if (!slot) {
        return null
    }

    let firstSlot

    if (Array.isArray(slot[0])) {
        firstSlot = slot[0] as SingleAdSlotSize
    } else {
        firstSlot = slot as SingleAdSlotSize
    }

    if (!firstSlot || firstSlot.length < 2) {
        return null
    }

    const gptSlot = getUniqueSlotSizeFromStandardSlot(firstSlot)

    if (!gptSlot) {
        return null
    }

    return { gptSlot, slot: firstSlot }
}
